export default __webpack_public_path__ + "static/media/pupster-img.22c558c3.png";